import { render, staticRenderFns } from "./UUID.vue?vue&type=template&id=6c39916d&scoped=true"
import script from "./UUID.vue?vue&type=script&lang=js"
export * from "./UUID.vue?vue&type=script&lang=js"
import style0 from "./UUID.vue?vue&type=style&index=0&id=6c39916d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39916d",
  null
  
)

export default component.exports